/**
 * Toggle classes
 * @module cookiesBanner
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'cookiesBanner';

const handleToggle = ($cookieBanner, $contentToShow, $contentToHide, activeClass) => {
  const startingHeight = $cookieBanner[0].offsetHeight;
  const $backToTop = $('.fixed-corner');
  const $attentiveNTF = $('#attentive_creative');
  $cookieBanner.css('height', startingHeight);
  if (activeClass) {
    $cookieBanner.removeClass('active');
  } else {
    $cookieBanner.addClass('active');

  }
  const newHeight = $contentToShow[0].offsetHeight + 14;
  $cookieBanner.animate({ height: newHeight }, 300);
  $backToTop.animate({ bottom: newHeight }, 300);
  $attentiveNTF.animate({ bottom: newHeight }, 300);
};

const handleClick = ($cookieBanner, $initialContent, $newContent) => {
  const hasActiveClass = $cookieBanner.hasClass('active');
  if (hasActiveClass) {
    handleToggle($cookieBanner, $initialContent, $newContent, true);
  } else {
    handleToggle($cookieBanner, $newContent, $initialContent, false);
  }
};

const handleScroll = (scrollPosY, $cookieBanner, $initialContent, $newContent) => {
  const hasActiveClass = $cookieBanner.hasClass('active');
  if (scrollPosY !== 0 && hasActiveClass) {
    handleToggle($cookieBanner, $initialContent, $newContent, true);
  } else if (scrollPosY === 0 && !hasActiveClass) {
    handleToggle($cookieBanner, $newContent, $initialContent, false);
  }
};

/**
 * Applies any sort of event handlers for the cookiesBanner.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el) => {
  const initialScrollPositon = $(window).scrollTop();
  const $cookieBanner = $el.closest('.cookies-banner');
  const $initialContent = $('.cookies-banner__head');
  const $newContent = $('.cookies-banner__details--v2');

  if (initialScrollPositon !== 0) {
    handleToggle($cookieBanner, $initialContent, $newContent, true);
  } else {
    handleToggle($cookieBanner, $newContent, $initialContent, false);
  }

  $el.on('click', () => {
    handleClick($cookieBanner, $initialContent, $newContent);
  });

  $(window).on('scroll resize', () => {
    const scrollPosY = $(window).scrollTop();
    handleScroll(scrollPosY, $cookieBanner, $initialContent, $newContent);
  });
};
/**
 * Initializes cookiesBanner.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function cookiesBanner(el) {
  const $el = $(el);
  setEventListeners($el);
}
registerJQueryPlugin(PLUGIN_NAME, cookiesBanner);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/cookies-banner.js